/**
 * DisabledActionButton — versión de una acción visualmente deshabilitada
 * que sigue siendo alcanzable por teclado (WCAG 2.1 AA — OT-0009 M1).
 *
 * Un `<button disabled>` nativo sale del orden de tabulación, así que el
 * `title` que explica el motivo del bloqueo nunca llega a un usuario que
 * navega con teclado. `role="button"` + `aria-disabled` + `tabIndex={0}`
 * mantiene el elemento enfocable — el navegador sigue mostrando el
 * `title` al enfocarlo — sin ejecutar ninguna acción (no lleva `onClick`:
 * estos controles no hacen nada mientras están deshabilitados).
 */
import type { ReactNode } from 'react'

export function DisabledActionButton({
  title,
  children,
  className,
}: {
  /** Explica POR QUÉ está bloqueado, no repite "no tienes permisos". */
  title: string
  children: ReactNode
  className?: string
}) {
  return (
    <span
      role="button"
      aria-disabled="true"
      tabIndex={0}
      title={title}
      className={
        className ??
        'text-xs text-ink-subtle cursor-not-allowed inline-flex items-center gap-1'
      }
    >
      {children}
    </span>
  )
}
